import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ExcelField } from 'src/const-data/form-field-mappings';
import { FormFieldDropdowns } from 'src/const-data/form-field-dropdowns';

export type FormFieldValue = string | number;

export type ExcelWriteMap = Partial<Record<ExcelField, FormFieldValue>>;

export type ExcelReadMap = Partial<Record<ExcelField, unknown>>;

@Injectable({
  providedIn: 'root'
})
export class FormDataService {
  constructor() {}

  public getDataFromDialog(form: FormGroup): ExcelWriteMap {
    const keyValuePair: ExcelWriteMap = {};

    for (const controlName of Object.keys(form.controls) as ExcelField[]) {
      const control = form.get(controlName);
      if (!control?.dirty || control.value === null || control.value === undefined) {
        continue;
      }

      keyValuePair[controlName] = FormFieldDropdowns.dropDowns[controlName]
        ? (control.value?.value ?? control.value)
        : control.value;

      control.markAsPristine();
    }

    return keyValuePair;
  }

  public getFormControlKeysArray(form: FormGroup): ExcelField[] {
    return Object.keys(form.controls) as ExcelField[];
  }

  public fillDataIntoDialog(form: FormGroup, dataToWrite: ExcelReadMap): void {
    if (dataToWrite === null || dataToWrite === undefined) return;

    for (const [controlName, control] of Object.entries(form.controls) as [ExcelField, AbstractControl][]) {
      if (FormFieldDropdowns.dropDowns[controlName]) {
        this.fillDropdownValue(control, controlName, dataToWrite);
      } else {
        control.setValue(dataToWrite[controlName] ?? null, { emitEvent: false });
      }
    }
  }

  private fillDropdownValue(control: AbstractControl, controlName: ExcelField, dataToWrite: ExcelReadMap) {
    const rawValue = dataToWrite[controlName];
    if (rawValue === null || rawValue === undefined) {
      control.setValue(undefined, { emitEvent: false });
      return;
    }
    const dropdownValue = FormFieldDropdowns.dropDowns[controlName].find(
      option => option.value.toString() === rawValue.toString()
    )?.value;
    control.setValue(dropdownValue, { emitEvent: false });
  }
}
